'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Created by Administrator on 2016/7/26.
                    */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactModal = require('react-modal');

var _reactModal2 = _interopRequireDefault(_reactModal);

var _SubmitBtn = require('../SubmitBtn/SubmitBtn');

var _SubmitBtn2 = _interopRequireDefault(_SubmitBtn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WechatPaymentModal = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(WechatPaymentModal, _Component);

  function WechatPaymentModal() {
    (0, _classCallCheck3.default)(this, WechatPaymentModal);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(WechatPaymentModal).call(this));
  }

  (0, _createClass3.default)(WechatPaymentModal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.currentSocket = this.initSocket();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.currentSocket.close();
    }
  }, {
    key: 'initSocket',
    value: function initSocket() {
      var _this2 = this;

      var _props = this.props;
      var user = _props.user;
      var data = _props.data;

      var socket = void 0;
      if ('WebSocket' in window) {
        if (user && user.userId && user.userId.split(',').length === 2) {
          console.log('WebSocket is supported by your browser.');

          // const serviceUrl = 'ws://115.182.102.130:1001'; 115.182.244.194
          // const serviceUrl = 'wss://ty.goeasy.cn:1001';
          var serviceUrl = 'wss://craftschina.goeasy.cn:1001';
          // dd const protocol = 'chat';
          socket = new WebSocket(serviceUrl);

          socket.onopen = function () {
            console.log('Connection Established!' + data.orderNumber);
            socket.send('{<' + data.orderNumber + '>}');
          };

          socket.onclose = function () {
            console.log('Connection Closed!');
          };

          socket.onerror = function (error) {
            console.log('Error Occured: ' + error);
          };

          socket.onmessage = function (event) {
            if (typeof event.data === 'string') {
              _this2.handleMessage(event.data);
            } else if (event.data instanceof ArrayBuffer) {
              console.log('ArrayBuffer received: ' + event.data);
            } else if (event.data instanceof Blob) {
              console.log('Blob received: ' + event.data);
            }
          };
        }
      }
      return socket;
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage(message) {
      var data = this.props.data;

      console.log(message);
      var result = void 0;
      var index = message.indexOf('{');
      if (index >= 0) {
        result = message.substr(index);
      }
      try {
        if (result && result !== '') {
          var info = JSON.parse(result);
          if (info.type === 'paymentInfo' && info.orderNumber === data.orderNumber) {
            if (info.success === 'true') {
              this.btnClick();
            } else {
              this.setState({ errorFromSocket: info.error });
            }
          }
        }
      } catch (ex) {
        console.log(ex.message);
      }
    }
  }, {
    key: 'btnClick',
    value: function btnClick(btn) {
      var onBtnClick = this.props.onBtnClick;

      if (onBtnClick) {
        onBtnClick(btn);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var styles = require('./WechatPaymentModal.scss');
      var _props2 = this.props;
      var data = _props2.data;
      var isOpened = _props2.isOpened;

      var customStyle = {
        content: {
          background: '#ffffff',
          overflow: 'hidden',
          outline: 'none',
          zIndex: 9999,
          border: '0',
          borderRadius: '30px',
          boxShadow: '3px 2px 20px',
          bottom: 'auto',
          minHeight: '10rem',
          left: '50%',
          padding: '2rem',
          position: 'fixed',
          right: 'auto',
          top: '50%',
          transform: 'translate(-50%,-50%)',
          minWidth: '20rem',
          width: '400px',
          maxWidth: '60rem'
        }
      };
      return _react2.default.createElement(
        _reactModal2.default,
        { style: customStyle, isOpen: isOpened },
        _react2.default.createElement(
          'div',
          { className: styles.img },
          _react2.default.createElement('img', { src: data.qrc })
        ),
        _react2.default.createElement(
          'div',
          { className: styles.text },
          '请使用微信扫码支付'
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_SubmitBtn2.default, { btnClick: function btnClick() {
              return _this3.btnClick('success');
            }, text: '确认支付' }),
          _react2.default.createElement(_SubmitBtn2.default, { btnClick: function btnClick() {
              return _this3.btnClick('back');
            }, text: '返回' })
        ),
        _react2.default.createElement('div', { className: 'clear' })
      );
    }
  }]);
  return WechatPaymentModal;
}(_react.Component), _class.propTypes = {
  data: _react.PropTypes.object,
  onBtnClick: _react.PropTypes.func,
  isOpened: _react.PropTypes.bool,
  user: _react.PropTypes.object
}, _temp);
exports.default = WechatPaymentModal;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/WechatPaymentModal/WechatPaymentModal.js
 ** module id = 1433
 ** module chunks = 0
 **/